import * as componentTypes from "../constants/componentTypes";
import * as settings from "../constants/settings";

export const isSearchPanelValid = (formulaStore, type = componentTypes.SEARCH_PANEL_DEFAULT, searchPanelOrder = []) => {
    if (formulaStore === undefined) {
        return false;
    }

    if (formulaStore.product === undefined || formulaStore.product === null) {
        return false;
    }

    if (formulaStore.fandeck === undefined || formulaStore.fandeck === null) {
        return false;
    }

    if (formulaStore.color === undefined || formulaStore.color === null) {
        return false;
    }

    if (type === componentTypes.SEARCH_PANEL_COLOR_PALETTE) {
        return formulaStore.color.hasFormula;
    }

    if (type === componentTypes.SEARCH_PANEL_COLOR_SEARCH) {
        return true;
    }

    if (
        searchPanelOrder.includes(componentTypes.SEARCH_PANEL_BASE) &&
        (formulaStore.base === undefined || formulaStore.base === null)
    ) {
        return false;
    }

    if (
        searchPanelOrder.includes(componentTypes.SEARCH_PANEL_BIPP) &&
        (formulaStore.bipp === undefined || formulaStore.bipp === null)
    ) {
        return false;
    }

    return formulaStore.color.hasFormula;
};

export const applyFocusOnNext = (tabId, activePanel, formulaStore, type, searchPanelOrder) => {
    let focusOnNext = false;
    let focusOn = null;
    let foncusOnIndex = -1;
    let index = 1;

    let searchFieldsOrder = searchPanelOrder;

    if (type === componentTypes.SEARCH_PANEL_COLOR_SEARCH) {
        if (window.jQuery("#tab-" + tabId + "-formula-name-select-box").length) {
            searchFieldsOrder = settings.SEARCH_PANEL_COLOR_SEARCH_ORDER;
        } else if (window.jQuery("#tab-" + tabId + "-formula-select-box").length) {
            searchFieldsOrder = settings.SEARCH_PANEL_COLOR_SEARCH_ORDER_WITH_COLOR_CODE;
        }
    }

    let panel;
    for (panel of searchFieldsOrder) {
        if (focusOn === null) {
            focusOn = panel;
            foncusOnIndex = index;
        }
        if (focusOnNext) {
            focusOn = panel;
            foncusOnIndex = index;
            focusOnNext = false;
        }
        if (panel === activePanel) {
            focusOnNext = true;
        }

        index++;
    }

    if (foncusOnIndex === 1) {
        if (isSearchPanelValid(formulaStore, type, searchFieldsOrder)) {
            if (window.jQuery("#tab-" + tabId + "-continue-button").length) {
                window.jQuery("#tab-" + tabId + "-continue-button").focus();
                return true;
            }
        }
    }

    switch (focusOn) {
        case componentTypes.SEARCH_PANEL_PRODUCT:
            window.jQuery("#tab-" + tabId + "-product-select-box").focus();
            break;
        case componentTypes.SEARCH_PANEL_FANDECK:
            window.jQuery("#tab-" + tabId + "-fandeck-select-box").focus();
            break;
        case componentTypes.SEARCH_PANEL_FORMULA:
            window.jQuery("#tab-" + tabId + "-formula-select-box").focus();
            break;
        case componentTypes.SEARCH_PANEL_FORMULA_NAME:
            window.jQuery("#tab-" + tabId + "-formula-name-select-box").focus();
            break;
        case componentTypes.SEARCH_PANEL_FORMULA_CODE:
            window.jQuery("#tab-" + tabId + "-formula-code-select-box").focus();
            break;
        case componentTypes.SEARCH_PANEL_BASE:
            window.jQuery("#tab-" + tabId + "-base-select-box").focus();
            break;
        case componentTypes.SEARCH_PANEL_BIPP:
            window.jQuery("#tab-" + tabId + "-bipp-select-box").focus();
            break;
        default:
            break;
    }

    return true;
};

export const applySmartFocus = (tabId, formulaStore, type, searchPanelOrder) => {
    if (
        tabId === undefined ||
        formulaStore === undefined ||
        formulaStore.product === undefined ||
        formulaStore.fandeck === undefined ||
        formulaStore.color === undefined ||
        formulaStore.base === undefined ||
        formulaStore.bipp === undefined
    ) {
        return false;
    }

    if (isSearchPanelValid(formulaStore, type, searchPanelOrder)) {
        if (window.jQuery("#tab-" + tabId + "-continue-button").length) {
            window.jQuery("#tab-" + tabId + "-continue-button").focus();
            return true;
        }

        if (document.activeElement !== null) {
            document.activeElement.blur();
        }

        return true;
    }

    if (type === componentTypes.SEARCH_PANEL_COLOR_PALETTE) {
        if (formulaStore.product === null) {
            window.jQuery("#tab-" + tabId + "-product-select-box").focus();
            return true;
        } else if (formulaStore.fandeck === null) {
            window.jQuery("#tab-" + tabId + "-fandeck-select-box").focus();
            return true;
        } else {
            if (document.activeElement !== null) {
                document.activeElement.blur();
            }
            return true;
        }
    }

    if (type === componentTypes.SEARCH_PANEL_COLOR_SEARCH) {
        if (formulaStore.fandeck === null) {
            window.jQuery("#tab-" + tabId + "-fandeck-select-box").focus();
            return true;
        } else if (formulaStore.color === null) {
            if (window.jQuery("#tab-" + tabId + "-formula-name-select-box").length) {
                window.jQuery("#tab-" + tabId + "-formula-name-select-box").focus();
            } else if (window.jQuery("#tab-" + tabId + "-formula-select-box").length) {
                window.jQuery("#tab-" + tabId + "-formula-select-box").focus();
            }
            return true;
        } else if (formulaStore.product === null) {
            window.jQuery("#tab-" + tabId + "-product-select-box").focus();
            return true;
        } else {
            if (document.activeElement !== null) {
                document.activeElement.blur();
            }
            return true;
        }
    }

    let previous = true;
    let focusOn = null;

    for (let type of searchPanelOrder) {
        switch (type) {
            case componentTypes.SEARCH_PANEL_PRODUCT:
                if (formulaStore.product === null) {
                    if (previous && focusOn === null) {
                        focusOn = componentTypes.SEARCH_PANEL_PRODUCT;
                    }

                    previous = false;
                } else {
                    previous = true;
                }

                break;
            case componentTypes.SEARCH_PANEL_FANDECK:
                if (formulaStore.fandeck === null) {
                    if (previous && focusOn === null) {
                        focusOn = componentTypes.SEARCH_PANEL_FANDECK;
                    }

                    previous = false;
                } else {
                    previous = true;
                }

                break;
            case componentTypes.SEARCH_PANEL_FORMULA:
                if (formulaStore.color === null) {
                    if (previous && focusOn === null) {
                        focusOn = componentTypes.SEARCH_PANEL_FORMULA;
                    }

                    previous = false;
                } else {
                    previous = true;
                }

                break;
            case componentTypes.SEARCH_PANEL_FORMULA_NAME:
                if (formulaStore.color === null) {
                    if (previous && focusOn === null) {
                        focusOn = componentTypes.SEARCH_PANEL_FORMULA_NAME;
                    }

                    previous = false;
                } else {
                    previous = true;
                }

                break;
            case componentTypes.SEARCH_PANEL_FORMULA_CODE:
                if (formulaStore.color === null) {
                    if (previous && focusOn === null) {
                        focusOn = componentTypes.SEARCH_PANEL_FORMULA_CODE;
                    }

                    previous = false;
                } else {
                    previous = true;
                }

                break;
            case componentTypes.SEARCH_PANEL_BASE:
                if (formulaStore.base === null) {
                    if (previous && focusOn === null) {
                        focusOn = componentTypes.SEARCH_PANEL_BASE;
                    }

                    previous = false;
                } else {
                    previous = true;
                }

                break;
            case componentTypes.SEARCH_PANEL_BIPP:
                if (formulaStore.bipp === null) {
                    if (previous && focusOn === null) {
                        focusOn = componentTypes.SEARCH_PANEL_BIPP;
                    }

                    previous = false;
                } else {
                    previous = true;
                }

                break;
            default:
                break;
        }
    }

    switch (focusOn) {
        case componentTypes.SEARCH_PANEL_PRODUCT:
            window.jQuery("#tab-" + tabId + "-product-select-box").focus();
            break;
        case componentTypes.SEARCH_PANEL_FANDECK:
            window.jQuery("#tab-" + tabId + "-fandeck-select-box").focus();
            break;
        case componentTypes.SEARCH_PANEL_FORMULA:
            window.jQuery("#tab-" + tabId + "-formula-select-box").focus();
            break;
        case componentTypes.SEARCH_PANEL_FORMULA_NAME:
            window.jQuery("#tab-" + tabId + "-formula-name-select-box").focus();
            break;
        case componentTypes.SEARCH_PANEL_FORMULA_CODE:
            window.jQuery("#tab-" + tabId + "-formula-code-select-box").focus();
            break;
        case componentTypes.SEARCH_PANEL_BASE:
            window.jQuery("#tab-" + tabId + "-base-select-box").focus();
            break;
        case componentTypes.SEARCH_PANEL_BIPP:
            window.jQuery("#tab-" + tabId + "-bipp-select-box").focus();
            break;
        default:
            break;
    }

    return true;
};

export const applySmartFocusForScene = (formulaStore, searchPanelOrder) => {
    if (isSearchPanelValid(formulaStore, componentTypes.SEARCH_PANEL_DEFAULT, searchPanelOrder)) {
        return componentTypes.PACKAGE_SCENE;
    }

    let previous = true;
    let focusOn = null;

    for (let type of searchPanelOrder) {
        switch (type) {
            case componentTypes.SEARCH_PANEL_PRODUCT:
                if (formulaStore.product === null) {
                    if (previous && focusOn === null) {
                        focusOn = componentTypes.PRODUCT_SCENE;
                    }

                    previous = false;
                } else {
                    previous = true;
                }

                break;
            case componentTypes.SEARCH_PANEL_FANDECK:
                if (formulaStore.fandeck === null) {
                    if (previous && focusOn === null) {
                        focusOn = componentTypes.FANDECK_SCENE;
                    }

                    previous = false;
                } else {
                    previous = true;
                }

                break;
            case componentTypes.SEARCH_PANEL_FORMULA:
            case componentTypes.SEARCH_PANEL_FORMULA_NAME:
            case componentTypes.SEARCH_PANEL_FORMULA_CODE:
                if (formulaStore.color === null) {
                    if (previous && focusOn === null) {
                        focusOn = componentTypes.COLOR_SCENE;
                    }

                    previous = false;
                } else {
                    previous = true;
                }

                break;
            case componentTypes.SEARCH_PANEL_BASE:
                if (formulaStore.base === null) {
                    if (previous && focusOn === null) {
                        focusOn = componentTypes.BASE_SCENE;
                    }

                    previous = false;
                } else {
                    previous = true;
                }

                break;
            case componentTypes.SEARCH_PANEL_BIPP:
                if (formulaStore.bipp === null) {
                    if (previous && focusOn === null) {
                        focusOn = componentTypes.BIPP_SCENE;
                    }

                    previous = false;
                } else {
                    previous = true;
                }

                break;
            default:
                break;
        }
    }

    if (focusOn === null) {
        return componentTypes.PACKAGE_SCENE;
    }

    return focusOn;
};

const setSearchItemSelectBoxHeight = (tabId, selectParentName, selectList, checkListOffsetListLength) => {
    if (checkListOffsetListLength) {
        return false;
    }

    let selectBox = window.jQuery("#tab-" + tabId + " " + selectParentName);

    if (selectBox.length === 0) {
        return false;
    }

    let selectBoxList = window.jQuery("#tab-" + tabId + " " + selectList);

    if (selectBoxList.length === 0) {
        return false;
    }

    let selectMaxHeight = 100;
    if (selectParentName === ".bipp-list") {
        selectMaxHeight =
            selectBox.parent().parent().innerHeight() -
            10 -
            selectBox.parent().position().top -
            selectBox.parent().outerHeight();
    } else {
        selectMaxHeight = selectBox.parent().innerHeight() - 10 - selectBox.position().top - selectBox.outerHeight();
    }

    selectBoxList.attr("style", "max-height: " + selectMaxHeight + "px !important");

    return true;
};

export const setSelectBoxHeight = (tabId, data, type) => {
    switch (type) {
        case componentTypes.SEARCH_PANEL_PRODUCT:
            setSearchItemSelectBoxHeight(tabId, ".product", ".product-list > ul", false);
            break;
        case componentTypes.SEARCH_PANEL_FANDECK:
            let groupCount = data.fandeckList.filter((group) => group.name !== "").length;

            setSearchItemSelectBoxHeight(
                tabId,
                ".fandeck",
                ".fandeck-list > ul",
                data.linearFandeckList.length - groupCount < 50 &&
                    data.fandeckListOffset === data.linearFandeckList.length - groupCount
            );
            break;
        case componentTypes.SEARCH_PANEL_FORMULA:
            setSearchItemSelectBoxHeight(
                tabId,
                ".formula",
                ".formula-list > ul",
                data.formulaList.length < 50 && data.formulaListOffset === data.formulaList.length
            );
            break;
        case componentTypes.SEARCH_PANEL_FORMULA_NAME:
            setSearchItemSelectBoxHeight(
                tabId,
                ".formula-name",
                ".formula-name-list > ul",
                data.formulaList.length < 50 && data.formulaListOffset === data.formulaList.length
            );
            break;
        case componentTypes.SEARCH_PANEL_FORMULA_CODE:
            setSearchItemSelectBoxHeight(
                tabId,
                ".formula-code",
                ".formula-code-list > ul",
                data.formulaCodeList.length < 50 && data.formulaCodeListOffset === data.formulaCodeList.length
            );
            break;
        case componentTypes.SEARCH_PANEL_BASE:
            setSearchItemSelectBoxHeight(
                tabId,
                ".base",
                ".base-list > ul",
                data.baseList.length < 50 && data.baseListOffset === data.baseList.length
            );
            break;
        case componentTypes.SEARCH_PANEL_BIPP:
            setSearchItemSelectBoxHeight(
                tabId,
                ".bipp-list",
                ".bipp-list .slim-scroll",
                data.bippList.length < 50 && data.bippListOffset === data.bippList.length
            );
            break;
        default:
            break;
    }
};

export const updateSelectBoxHeight = (tabId, searchPanel, searchPanelOrder) => {
    for (let type of searchPanelOrder) {
        setSelectBoxHeight(tabId, searchPanel, type);
    }
};

export const getSearchPanelType = (tabType) => {
    switch (tabType) {
        case componentTypes.COLOR_TAB:
            return componentTypes.SEARCH_PANEL_COLOR_PALETTE;
        case componentTypes.COLOR_SEARCH_TAB:
            return componentTypes.SEARCH_PANEL_COLOR_SEARCH;
        default:
            return componentTypes.SEARCH_PANEL_DEFAULT;
    }
};

export const getBaseIdForCalculatedFormula = (type, base, searchPanelBaseActive) => {
    if (type === componentTypes.SEARCH_PANEL_COLOR_PALETTE || base === null || !searchPanelBaseActive) {
        return null;
    }

    return base.id;
};

export const getBippIdForCalculatedFormula = (type, bipp, searchPanelBippActive) => {
    if (type === componentTypes.SEARCH_PANEL_COLOR_PALETTE || bipp === null || !searchPanelBippActive) {
        return null;
    }

    return bipp.id;
};

export const isSearchPanelFilterActive = (type, searchPanelInputActive) => {
    if (type === componentTypes.SEARCH_PANEL_COLOR_PALETTE || type === componentTypes.SEARCH_PANEL_COLOR_SEARCH) {
        return true;
    }

    return searchPanelInputActive;
};

export const isSearchPanelBaseFilterActive = (type, searchPanelInputActive) => {
    if (type === componentTypes.SEARCH_PANEL_COLOR_PALETTE || type === componentTypes.SEARCH_PANEL_COLOR_SEARCH) {
        return false;
    }

    return searchPanelInputActive;
};

export const isSearchPanelBippFilterActive = (type, searchPanelInputActive) => {
    if (type === componentTypes.SEARCH_PANEL_COLOR_PALETTE || type === componentTypes.SEARCH_PANEL_COLOR_SEARCH) {
        return false;
    }

    return searchPanelInputActive;
};

export const getStateAfterRemoveSelectedItem = (
    tabId,
    panel,
    searchPanelStore,
    formulaStore,
    searchPanelOrder,
    searchPanelFormulaCodeActive,
    searchPanelProductActive,
    searchPanelBaseActive,
    intergammaColorFandeckWizard,
    gammaSoftware
) => {
    let update = {
        tabId: tabId,
        product: formulaStore.product,
        fandeck: formulaStore.fandeck,
        color: formulaStore.color,
        base: formulaStore.base,
        bipp: formulaStore.bipp,
        productNameInput: searchPanelStore.productNameInput,
        fandeckNameInput: searchPanelStore.fandeckNameInput,
        formulaNameInput: searchPanelStore.formulaNameInput,
        formulaCodeInput: searchPanelStore.formulaCodeInput,
        baseNameInput: searchPanelStore.baseNameInput,
        bippNameInput: searchPanelStore.bippNameInput,
        productNameFilter: searchPanelStore.productNameFilter,
        fandeckNameFilter: searchPanelStore.fandeckNameFilter,
        formulaNameFilter: searchPanelStore.formulaNameFilter
    };
    let checked = {
        product: false,
        fandeck: false,
        color: false,
        base: false,
        bipp: false
    };
    let checkedInputs = {
        productNameInput: false,
        fandeckNameInput: false,
        formulaNameInput: false,
        formulaCodeInput: false,
        baseNameInput: false,
        bippNameInput: false
    };

    let searchFieldsOrder = searchPanelOrder;

    if (searchPanelStore.type === componentTypes.SEARCH_PANEL_COLOR_PALETTE) {
        searchFieldsOrder = searchFieldsOrder
            .filter(
                (type) => type === componentTypes.SEARCH_PANEL_PRODUCT || type === componentTypes.SEARCH_PANEL_FANDECK
            )
            .concat([componentTypes.SEARCH_PANEL_FORMULA]);
    }

    if (searchPanelStore.type === componentTypes.SEARCH_PANEL_COLOR_SEARCH) {
        searchFieldsOrder = searchPanelFormulaCodeActive
            ? settings.SEARCH_PANEL_COLOR_SEARCH_ORDER_WITH_COLOR_CODE
            : settings.SEARCH_PANEL_COLOR_SEARCH_ORDER;
    }

    if (gammaSoftware) {
        if (intergammaColorFandeckWizard) {
            if (panel === componentTypes.SEARCH_PANEL_FORMULA) {
                searchFieldsOrder = [componentTypes.SEARCH_PANEL_FANDECK, componentTypes.SEARCH_PANEL_FORMULA];
            } else {
                searchFieldsOrder = [componentTypes.SEARCH_PANEL_FORMULA, componentTypes.SEARCH_PANEL_FANDECK];
            }

            searchFieldsOrder.push(componentTypes.SEARCH_PANEL_PRODUCT);
            searchFieldsOrder.push(componentTypes.SEARCH_PANEL_BIPP);
        }
    }

    let item = null;
    let reset = false;
    for (item of searchFieldsOrder) {
        switch (item) {
            case componentTypes.SEARCH_PANEL_PRODUCT:
                if (reset || item === panel) {
                    if (reset) {
                        update.productNameInput = "";
                        update.productNameFilter = "";
                    }

                    update.product = null;
                    reset = true;
                }

                checked.product = true;
                checkedInputs.productNameInput = true;
                break;
            case componentTypes.SEARCH_PANEL_FANDECK:
                if (reset || item === panel) {
                    if (reset) {
                        update.fandeckNameInput = "";
                        update.fandeckNameFilter = "";
                    }

                    update.fandeck = null;
                    reset = true;
                }

                checked.fandeck = true;
                checkedInputs.fandeckNameInput = true;
                break;
            case componentTypes.SEARCH_PANEL_FORMULA:
                if (reset || item === panel) {
                    if (reset && update.color !== null) {
                        update.formulaNameInput = "";
                        update.formulaCodeInput = "";
                        update.formulaNameFilter = "";
                    }

                    update.color = null;
                    reset = true;
                }

                checked.color = true;
                checkedInputs.formulaNameInput = true;
                checkedInputs.formulaCodeInput = true;
                break;
            case componentTypes.SEARCH_PANEL_FORMULA_NAME:
                if (reset || item === panel) {
                    if (!checked.color) {
                        if (reset && update.color !== null) {
                            update.formulaNameInput = "";
                            update.formulaNameFilter = "";
                        }

                        update.color = null;
                    }

                    reset = true;
                }

                if (componentTypes.SEARCH_PANEL_FORMULA_CODE === panel && !checked.color) {
                    if (reset && update.color !== null) {
                        update.formulaNameInput = "";
                        update.formulaNameFilter = "";
                    }

                    update.color = null;
                }

                if (checked.color && update.color === null) {
                    update.formulaNameInput = "";
                    update.formulaNameFilter = "";
                }

                checked.color = true;
                checkedInputs.formulaNameInput = true;
                break;
            case componentTypes.SEARCH_PANEL_FORMULA_CODE:
                if (reset || item === panel) {
                    if (!checked.color) {
                        if (reset && update.color !== null) {
                            update.formulaCodeInput = "";
                        }

                        update.color = null;
                    }

                    reset = true;
                }

                if (componentTypes.SEARCH_PANEL_FORMULA_NAME === panel && !checked.color) {
                    if (reset && update.color !== null) {
                        update.formulaCodeInput = "";
                    }

                    update.color = null;
                }

                if (checked.color && update.color === null) {
                    update.formulaCodeInput = "";
                }

                checked.color = true;
                checkedInputs.formulaCodeInput = true;
                break;
            case componentTypes.SEARCH_PANEL_BASE:
                if (reset || item === panel) {
                    if (reset) {
                        update.baseNameInput = "";
                    }

                    update.base = null;
                    reset = true;
                }

                checked.base = true;
                checkedInputs.baseNameInput = true;
                break;
            case componentTypes.SEARCH_PANEL_BIPP:
                if (reset || item === panel) {
                    if (reset) {
                        update.bippNameInput = "";
                    }

                    if (!searchPanelProductActive) {
                        if (reset) {
                            update.productNameInput = "";
                        }

                        update.product = null;
                    }

                    update.bipp = null;
                    reset = true;
                }

                checked.bipp = true;
                checkedInputs.bippNameInput = true;
                checked.product = true;
                checkedInputs.productNameInput = true;
                break;
            default:
                break;
        }
    }

    if (!searchPanelBaseActive) {
        update.base = null;
    }

    for (let attr in checked) {
        if (!checked[attr]) {
            update[attr] = null;
        }
    }

    for (let attr in checkedInputs) {
        if (!checkedInputs[attr]) {
            update[attr] = "";
        }
    }

    return update;
};
